import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import SimplePagination from "./SimplePagination";
import Period from "./Period";
import { LangContext } from "../LangContext.jsx";
class Periods extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            total: 0,
            items: [],
           
        };
    }

    componentDidMount() { 
        this.getData()
         
    }

    async getData(){ 
        const res = await axios.post('/api/periods',{
            person_provider_id:this.props.person_provider_id,
            person_document_id:this.props.person_document_id
        });

        this.setState({
            items: res.data.items || [],
            total: res.data.total || 0,
        });
    }

    render() {
        const lang = this.context.lang;

        return (
            <>
                <div className="card card-custom gutter-b my-5">
                    <div className="card-header border-0 pt-7 mb-5 d-block">
                        <h3 className="card-title align-items-start flex-column mb-8">
                            <span className="card-label font-weight-bolder font-size-h4 text-dark-75">{lang.get('messages.cfdi_nomina')}</span>
                            <span className="text-muted mt-3 font-weight-bold font-size-sm">{this.state.total} {lang.get('messages.documentos_disponibles')}</span>
                        
                        </h3>
                        <div className="d-flex justify-content-between mb-2 font-weight-bold">
                            <div>Nombre del archivo: <strong className="text-dark"> {this.props.filename} </strong></div>
                            <div>Número de archivos XMLs: <strong className="text-dark">{this.state.total}</strong></div>
                            <div>Fecha de cargo: <strong className="text-dark">{this.props.uploaddate} </strong></div>
                            <div>Tipo CFDI: <strong className="text-dark">Nómina</strong></div>
                        </div>
                    </div>
                    <div className="card-body p-0">

                        {this.state.items.map((item, i) => (
                            <div key={i}>
                                <Period person_provider_id={this.props.person_provider_id} person_document_id={this.props.person_document_id} month={item.month} year={item.year} />
                            </div>
                        ))}

                    </div>
                </div>
            </>
        );
    }
}

export default Periods;

if (document.getElementById('Periods')) {
    ReactDOM.render(<Periods />, document.getElementById('Periods'));
}
